import styled from "styled-components";

const TitleSection = styled.div`
  display: flex;
  height: 20px;
`;

export default TitleSection;
